import {Platform} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';
import {Theme} from '../../theme/interface';

export const useTabsStyles = () => {
  const tabShadowStyle = (theme: Theme) =>
    Platform.OS !== 'web'
      ? {
          borderWidth: 1,
          borderColor: theme.color.primaryColor,
          shadowColor: theme.color.primaryColor,
          shadowRadius: 4,
          backgroundColor: theme.color.primaryNonGreyBackground,
        }
      : undefined;
  return useStyles(({theme, mediaOnly}) => ({
    tabs: {
      width: '100%',
    },
    tabButtons: {
      marginBottom: 22,
      display: 'flex',
      flexDirection: 'row',
    },
    tab: {
      ...mediaOnly(
        DeviceSize.mobile,
        {
          display: 'flex',
          justifyContent: 'center',
          ...tabShadowStyle(theme),

          elevation: 5,
          flex: 1,
          lineHeight: 35,
          borderWidth: 1,
          borderColor: theme.color.primaryColor,
          shadowColor: theme.color.primaryColor,
          shadowRadius: 1,
          backgroundColor: theme.color.primaryNonGreyBackground,
        },
        {marginRight: 20},
      ),
    },
    textCenter: {
      marginRight: 0,
      paddingHorizontal: 16,
    },
    firstTab: {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    lastTab: {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
    tabText: {
      ...mediaOnly(DeviceSize.mobile, {
        paddingVertical: 1,
        fontSize: 18,
        lineHeight: 35,
        textAlign: 'center',
      }),
      ...mediaOnly(DeviceSize.tablet, {paddingVertical: 3, fontSize: 18, lineHeight: 35, textAlign: 'center'}),
      ...mediaOnly(DeviceSize.desktop, {paddingVertical: 3, fontSize: 30, lineHeight: 45}),
      fontWeight: '500',
    },
    tabTextSmall: {
      ...mediaOnly(DeviceSize.mobile, {
        paddingVertical: 1,
        fontSize: 12,
        lineHeight: 18,
      }),
      ...mediaOnly(DeviceSize.tablet, {paddingVertical: 3, fontSize: 16, lineHeight: 20}),
      ...mediaOnly(DeviceSize.desktop, {paddingVertical: 3, fontSize: 18, lineHeight: 24}),
      fontWeight: '500',
    },
    activeTab: {
      color: theme.color.primaryColor,
    },
    underlineActiveTab: {
      ...mediaOnly(
        DeviceSize.mobile,
        {},
        {
          borderBottomWidth: 2,
          borderBottomColor: theme.color.primaryColor,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      ),
    },
    inactiveTab: {
      ...mediaOnly(DeviceSize.desktop, {color: 'rgb(130, 130, 130)'}, {color: theme.color.textColor}),
    },
    tabContent: {
      width: '100%',
    },
    emptyText: {
      ...mediaOnly(DeviceSize.mobile, {
        paddingVertical: 15,
        fontSize: 18,
        lineHeight: 35,
      }),
      ...mediaOnly(DeviceSize.tablet, {paddingVertical: 15, fontSize: 18, lineHeight: 35}),
      ...mediaOnly(DeviceSize.desktop, {paddingVertical: 30, fontSize: 18, lineHeight: 35}),

      textAlign: 'center',
    },
  }));
};
